// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EditCancellation-commonHeaderAdmin-IaSGv {
	position: fixed !important;
}

.EditCancellation-adminLayout-faCeg {
	padding-top: 64px !important;
}

.EditCancellation-box-j5FUG h2 {
	font-size: 21px;
	font-weight: 600;
}

.EditCancellation-exportLink-hf2go {
	margin-bottom: -29px;
}

.EditCancellation-blockCenter-ePAX5 {
	float: none !important;
	display: block;
	margin: 0 auto;
	margin-top: 30px;
}

.EditCancellation-panelHeader-U0gM3 {
	padding-bottom: 18px !important;
	padding: 24px 15px;
	border-radius: 6px !important;
	border: 1px solid var(--primary-border)
}

.EditCancellation-currencyselect-_1pfD {
	width: 100%;
	margin-right: 0px;
}

.EditCancellation-panelHeader-U0gM3 {
	overflow: hidden;
	position: relative;
}

.EditCancellation-mar0-_6onr {
	margin-left: 0;
	margin-right: 0;
}

@media screen and (max-width: 767px) {
	.EditCancellation-blockCenter-ePAX5 {
		padding: 0px;
	}

	.EditCancellation-panelHeader-U0gM3 {
		padding: 24px 5px;
	}
}

/** Admin - Common - Start **/

.EditCancellation-sideAdminPageWrapper-PcDxi {
	margin-left: var(--siteAdmin-sideBar-width);
	position: relative;
	padding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;
}

.EditCancellation-panelHeader-U0gM3 {
	border-radius: 0;
	width: 100%;
	display: block;
	font-size: 16px;
	padding-bottom: 12px;
	border-bottom: 1px solid var(--primary-border);
	background-color: var(--background-primary);
}

.EditCancellation-table-gQEZE {
	display: table;
}

.EditCancellation-tableRow-EwGn1 {
	display: table-row;
}

.EditCancellation-tableCell-XaN4U {
	display: table-cell;
	float: none;
}

.EditCancellation-formGroup-aPIAD {
	margin-bottom: 6px;
}

.EditCancellation-select-rvuZv {
	position: relative;
	display: inline-block;
	vertical-align: bottom;
	margin-right: 5px;
}

.EditCancellation-noMargin-wcGJx {
	margin: 0px;
}

a,
a:hover {
	cursor: pointer;
}

.EditCancellation-exportLink-hf2go {
	padding-top: 10px;
	padding-right: 10px;
}

.EditCancellation-labelTextNew-YNZZJ {
	font-size: 16px;
	line-height: 24px;
	font-weight: 600;
	margin: 0 0 6px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditCancellation-displayInline-LxLyr {
	display: inline-block;
}

/******************* Admin Modal ListSetting Start *******************/

.EditCancellation-btnUPdate-Q6BHw {
	display: inline-block;
}

.EditCancellation-btnModalDelete-iP62s {
	display: inline-block;
	margin-left: 15px;
}

.EditCancellation-radioBtn-jFqsK {
	position: relative;
	top: 1px;
	vertical-align: middle;
}

.EditCancellation-backgroundImg-eeYOe {
	padding-top: 80%;
	background-position: top center;
	background-size: cover;
}

@media screen and (max-width: 767px) {
	.EditCancellation-btnUPdate-Q6BHw {
		display: block;
		margin-bottom: 12px;
	}

	.EditCancellation-btnModalDelete-iP62s {
		display: block;
		margin-left: 0px;
	}

	.EditCancellation-btnWidth-KNWJH {
		width: 100%;
	}
}

/******************* Admin Modal ListSetting Start *******************/

/******************* Admin Banner Image Section Start ****************/

.EditCancellation-bannerImageBg-dNUdY {
	padding-top: 60%;
	background-repeat: no-repeat;
	background-size: contain;
	border-radius: 4px;
	background-position: center;
	background-color: var(--secondary-gray-bg);
	border: 1px dashed var(--primary-border);
}

.EditCancellation-bannerDelete-EYcLJ {
	position: absolute;
	top: -12px;
	right: 4px;
}

/*******************Admin Modal Start **********************/

.EditCancellation-modalRoot-hYAgu {
	padding: 32px;
}

.EditCancellation-modalBorderBottom-ZK1lP {
	border-bottom: 5px solid var(--primary-bg);
	border-bottom-left-radius: 14px;
	border-bottom-right-radius: 14px;
}

.EditCancellation-logInModalBody-jRcrQ {
	padding: 0px;
}

/*************** Admin TableNew Design Start**************************/

.EditCancellation-exportSection-V4ElJ {
	background: #f5f5f5;
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border-top-left-radius: 6px;
	border-top-right-radius: 6px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
}

.EditCancellation-exportSectionGridSub-Fcrwx {
	grid-template-columns: 50% 49% !important;
}

.EditCancellation-exportText-vKAKo {
	color: var(--primary-foreground) !important;
	text-decoration: none !important;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 12px;
}

.EditCancellation-exportLinkImg-mogP7 {
	background: var(--common-white-primary-bg);
	padding: 10px;
	border-radius: 4px;
	display: inline-block;
}

.EditCancellation-vtrMiddle-OQ5wd {
	vertical-align: middle;
}

.EditCancellation-exportImg-E0jJM {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.EditCancellation-profileViewlabel-TSCp8 {
	display: inline-block;
	width: 38%
}

.EditCancellation-profileViewMainContent-IUw1n {
	display: inline-block;
	width: 62%;
}

.EditCancellation-profileViewMain-BieaE {
	border: 1px solid var(--primary-border);
	border-radius: 6px;
}

.EditCancellation-profileViewInner-pF6Ti {
	padding: 10px;
	border-bottom: 1px solid var(--primary-border);
}

.EditCancellation-profileImageSection-F7u3J {
	width: 100%;
	height: 100px;
	max-width: 100px;
	max-height: 100px;
	border-radius: 50%;
}

.EditCancellation-lastviewInner-RWSN_ {
	padding: 10px;
}

.EditCancellation-whyHostHoriLine-hU3Ib {
	margin: 30px 0;
}

.EditCancellation-tableGrid-k3Jzc {
	display: grid;
	grid-template-columns: 50% 50%;
	-webkit-column-gap: 10px;
	   -moz-column-gap: 10px;
	        column-gap: 10px;
	word-wrap: break-word;
}

.EditCancellation-headingContent-yf8H5 {
	font-size: 18px;
	font-weight: 500;
}

.EditCancellation-refundTextColor-YfkBm {
	color: var(--alert-color);
	font-size: 18px;
	text-decoration: line-through;
	text-decoration-thickness: 2px;
	text-decoration-color: var(--black-color);
}

.EditCancellation-dividerLine-JMcBi {
	border-top: 1px solid var(--primary-border);
	margin: 30px 0;
}

.EditCancellation-smallContent-bHZ0s {
	font-size: 14px;
	margin-top: 6px;
	color: var(--secondary-foreground);
}

@media (max-width: 1200px) and (min-width: 1024px) {
	.EditCancellation-sideAdminPageWrapper-PcDxi {
		height: 100%;
		overflow: auto;
	}
}

@media (max-width:1199px) {
	.EditCancellation-sideAdminPageWrapper-PcDxi {
		margin-left: 0;
	}
}

@media screen and (max-width: 991px) {
	.EditCancellation-exportSection-V4ElJ {
		grid-template-columns: 100%;
	}

	.EditCancellation-exportSectionGridSub-Fcrwx {
		grid-template-columns: 100% !important;
	}

}

@media screen and (max-width: 767px) {
	.EditCancellation-profileViewlabel-TSCp8 {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.EditCancellation-profileViewMainContent-IUw1n {
		width: 100%;
		text-align: center;
	}
}

/*************** Admin TableNew Design End**************************/

.EditCancellation-ChangeToUpperCase-EABJP {
	text-transform: uppercase
}

.EditCancellation-noBorder-zwtWw {
	border: 0px !important;
}

/** Admin - Common - End **/

/* site Admin utility Start */

.EditCancellation-siteAdminHeading-UYbNw {
	font-size: 24px;
	line-height: 32px;
	font-weight: 700;
	margin: 0 0 24px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditCancellation-siteAdminSubHeading-bgNJ3 {
	font-size: 18px;
	line-height: 26px;
	font-weight: 600;
	margin: 0 0 12px;
	text-align: start;
	color: var(--primary-foreground);
}

.EditCancellation-adminFormDivider-tw0cO {
	border-top: 1px solid var(--primary-border);
	margin-bottom: 24px;
}

.EditCancellation-errorMessage-AP3o4 {
  margin: 5px 0px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
}

.EditCancellation-panelHeader-U0gM3 {
  border-radius: 0;
  width: 100%;
  display: block;
  font-size: 16px;
  padding-bottom: 12px;
  border-bottom: 1px solid var(--primary-border);
}

.EditCancellation-formGroup-aPIAD {
  margin-bottom: 6px;
}

.EditCancellation-select-rvuZv {
  position: relative;
  display: inline-block;
  vertical-align: bottom;
  margin-right: 5px;
}

.EditCancellation-labelText-bzbdt {
  font-size: 14px;
  color: var(--secondary-foreground);
  margin: 6px 0px;
  line-height: 1.43;
  font-weight: normal;
  vertical-align: middle;
}

.EditCancellation-space1-zVLKW {
	margin-bottom: 6px !important;
}

.EditCancellation-space2-TWNc6 {
	margin-bottom: 12px !important;
}

.EditCancellation-space3-phJpk {
	margin-bottom: 18px !important;
}

.EditCancellation-space4-qNdxE {
	margin-bottom: 24px !important;
}

.EditCancellation-space5-guK3I {
	margin-bottom: 30px !important;
}

.EditCancellation-space6-SPbrA {
	margin-bottom: 36px !important;
}

.EditCancellation-space7-eo6De {
	margin-bottom: 42px !important;
}

.EditCancellation-spaceTop8-L7NZj {
	margin-bottom: 48px !important;
}

.EditCancellation-spaceTop1-s5INw {
	margin-top: 6px !important;
}

.EditCancellation-spaceTop2-qQy4q {
	margin-top: 12px !important;
}

.EditCancellation-spaceTop3-Y3UGh {
	margin-top: 18px !important;
}

.EditCancellation-spaceTop4-w1Zb4 {
	margin-top: 24px !important;
}

.EditCancellation-spaceTop5-AueTe {
	margin-top: 30px !important;
}

.EditCancellation-spaceTop6-xFy98 {
	margin-top: 36px !important;
}

.EditCancellation-spaceTop7-R4kGQ {
	margin-top: 42px !important;
}

.EditCancellation-spaceTop8-L7NZj {
	margin-top: 48px !important;
}

.EditCancellation-noMargin-wcGJx {
	margin: 0px !important;
}

.EditCancellation-padding1-DWAqD {
	padding-bottom: 6px !important;
}

.EditCancellation-padding2-N7Pvg {
	padding-bottom: 12px !important;
}

.EditCancellation-padding3-pEWfl {
	padding-bottom: 18px !important;
}

.EditCancellation-padding4-w446A {
	padding-bottom: 24px !important;
}

.EditCancellation-padding5-_OWJ6 {
	padding-bottom: 30px !important;
}

.EditCancellation-padding6-IMqgb {
	padding-bottom: 36px !important;
}

.EditCancellation-padding7-zMUo6 {
	padding-bottom: 42px !important;
}

.EditCancellation-paddingTop1-OHjtp {
	padding-top: 6px !important;
}

.EditCancellation-paddingTop2-PBVtl {
	padding-top: 12px !important;
}

.EditCancellation-paddingTop3-C8yX5 {
	padding-top: 18px !important;
}

.EditCancellation-paddingTop4-Fiw0E {
	padding-top: 24px !important;
}

.EditCancellation-paddingTop5-M7RYc {
	padding-top: 30px !important;
}

.EditCancellation-paddingTop6-FUYuR {
	padding-top: 36px !important;
}

.EditCancellation-paddingTop7-Le7Jr {
	padding-top: 42px !important;
}

.EditCancellation-noPadding-pGDtO {
	padding: 0px !important;
}

.EditCancellation-textBold-Dlivv {
	font-weight: 500 !important;
}

.EditCancellation-textBolder-PAWPl {
	font-weight: 700 !important;
}

.EditCancellation-textNormal-KkeeM {
	font-weight: normal !important;
}

.EditCancellation-spaceBottom20-DU23c {
	margin-bottom: 20px;
}

.EditCancellation-spaceBottom10-GhnG1 {
	margin-bottom: 10px;
}

.EditCancellation-marginNone-oa5ss {
	margin: 0;
}

.EditCancellation-spaceBottom15-k9MGe {
	margin-bottom: 15px;
}

.EditCancellation-marginTopNone-YUJ7j {
	margin-top: 0;
}

.EditCancellation-spaceTop11-r2IsV {
	margin-top: 11px;
}

.EditCancellation-spaceTop21-lXZbo {
	margin-top: 21px;
}

.EditCancellation-spaceTop20-L5Zf1 {
	margin-top: 20px;
}

.EditCancellation-spaceTop10-hekGy {
	margin-top: 10px;
}

/*New Design Text Colors */

.EditCancellation-textDarkBlue-fqmOY {
	color: rgb(20, 39, 94) !important;
}

.EditCancellation-textLightBlue-FgwjR {
	color: rgb(57, 87, 106) !important;
}

.EditCancellation-textLightSandleGreen-gvUpo {
	color: rgb(76, 86, 41) !important;
}

.EditCancellation-textLightBrown-DprQR {
	color: rgb(115, 79, 33) !important;
}

.EditCancellation-textMediumMaroon-vDgeM {
	color: rgb(87, 37, 51) !important;
}

.EditCancellation-textBrown-mDudH {
	color: rgb(160, 47, 24) !important;
}

.EditCancellation-textMaroon-KcGQ5 {
	color: rgb(155, 49, 67) !important;
}

.EditCancellation-textDarkBrown-g6riu {
	color: rgb(83, 18, 16) !important;
}

.EditCancellation-textMediumBrown-jbNWf {
	color: rgb(142, 28, 10) !important;
}

.EditCancellation-textSkyBlue-rPc_D {
	color: rgb(37, 117, 141) !important;
}

.EditCancellation-textGray-Fx_Kq {
	color: rgb(77, 65, 51) !important;
}

.EditCancellation-faqImage-astH5 {
    width: 100%;
    max-width: 20px;
    margin-left: 3px;
    margin-bottom: 3px;
}

.EditCancellation-labelAddon-eWOUb {
    display: inline;
}

.EditCancellation-labelAddonSec-G80T9 {
    margin: 6px 0;
}

.EditCancellation-addonStyle-TB1eC {
    border: 1px solid var(--primary-border) !important;
}

.EditCancellation-displayGrid-cD8Ca {
    display: grid;
    grid-template-columns: 49% 49%;
    grid-column-gap: 20px;
}

@media screen and (max-width: 1199px) {
    .EditCancellation-displayGrid-cD8Ca {
        grid-template-columns: 100%;
    }
}

@media screen and (max-width:767px) {
    .EditCancellation-panelHeader-U0gM3 {
        padding: 24px 15px !important;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/siteadmin/newcommonstyle.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-form.css","webpack://./src/components/helpers.css","webpack://./src/components/siteadmin/CancellationPolicy/EditCancellation/EditCancellation.css"],"names":[],"mappings":"AAAA;CACC,0BAA0B;AAC3B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,oBAAoB;AACrB;;AAEA;CACC,sBAAsB;CACtB,cAAc;CACd,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,+BAA+B;CAC/B,kBAAkB;CAClB,6BAA6B;CAC7B;AACD;;AAEA;CACC,WAAW;CACX,iBAAiB;AAClB;;AAEA;CACC,gBAAgB;CAChB,kBAAkB;AACnB;;AAEA;CACC,cAAc;CACd,eAAe;AAChB;;AAEA;CACC;EACC,YAAY;CACb;;CAEA;EACC,iBAAiB;CAClB;AACD;;ACpDA,6BAA6B;;AAC7B;CACC,2CAA2C;CAC3C,kBAAkB;CAClB,+DAA+D;AAChE;;AAEA;CACC,gBAAgB;CAChB,WAAW;CACX,cAAc;CACd,eAAe;CACf,oBAAoB;CACpB,8CAA8C;CAC9C,2CAA2C;AAC5C;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,qBAAqB;CACrB,sBAAsB;CACtB,iBAAiB;AAClB;;AAEA;CACC,WAAW;AACZ;;AAEA;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,qBAAqB;AACtB;;AAEA,sEAAsE;;AAEtE;CACC,qBAAqB;AACtB;;AAEA;CACC,qBAAqB;CACrB,iBAAiB;AAClB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,sBAAsB;AACvB;;AAEA;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,sBAAsB;AACvB;;AAEA;CACC;EACC,cAAc;EACd,mBAAmB;CACpB;;CAEA;EACC,cAAc;EACd,gBAAgB;CACjB;;CAEA;EACC,WAAW;CACZ;AACD;;AAEA,sEAAsE;;AAEtE,sEAAsE;;AAEtE;CACC,gBAAgB;CAChB,4BAA4B;CAC5B,wBAAwB;CACxB,kBAAkB;CAClB,2BAA2B;CAC3B,0CAA0C;CAC1C,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;CAClB,UAAU;CACV,UAAU;AACX;;AAEA,4DAA4D;;AAE5D;CACC,aAAa;AACd;;AAEA;CACC,0CAA0C;CAC1C,+BAA+B;CAC/B,gCAAgC;AACjC;;AAEA;CACC,YAAY;AACb;;AAEA,sEAAsE;;AAEtE;CACC,mBAAmB;CACnB,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,2BAA2B;CAC3B,4BAA4B;CAC5B,uCAAuC;CACvC,gBAAgB;AACjB;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,gCAAgC;CAChC,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,SAAS;AACV;;AAEA;CACC,0CAA0C;CAC1C,aAAa;CACb,kBAAkB;CAClB,qBAAqB;AACtB;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB;AACD;;AAEA;CACC,qBAAqB;CACrB,UAAU;AACX;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;AACnB;;AAEA;CACC,aAAa;CACb,8CAA8C;AAC/C;;AAEA;CACC,WAAW;CACX,aAAa;CACb,gBAAgB;CAChB,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,aAAa;CACb,8BAA8B;CAC9B,wBAAgB;IAAhB,qBAAgB;SAAhB,gBAAgB;CAChB,qBAAqB;AACtB;;AAEA;CACC,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,6BAA6B;CAC7B,8BAA8B;CAC9B,yCAAyC;AAC1C;;AAEA;CACC,2CAA2C;CAC3C,cAAc;AACf;;AAEA;CACC,eAAe;CACf,eAAe;CACf,kCAAkC;AACnC;;AAEA;CACC;EACC,YAAY;EACZ,cAAc;CACf;AACD;;AAEA;CACC;EACC,cAAc;CACf;AACD;;AAEA;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,sCAAsC;CACvC;;AAED;;AAEA;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;AACD;;AAEA,oEAAoE;;AAEpE;CACC;AACD;;AAEA;CACC,sBAAsB;AACvB;;AAEA,2BAA2B;;AAE3B,6BAA6B;;AAC7B;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,eAAe;CACf,iBAAiB;CACjB,gBAAgB;CAChB,gBAAgB;CAChB,iBAAiB;CACjB,gCAAgC;AACjC;;AAEA;CACC,2CAA2C;CAC3C,mBAAmB;AACpB;;ACvUA;EACE,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;;ACJA;EACE,gBAAgB;EAChB,WAAW;EACX,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,8CAA8C;AAChD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,kCAAkC;EAClC,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AC7BA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,SAAS;AACV;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,gBAAgB;AACjB;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;ACxNA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kDAAkD;AACtD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;AACzB;;AAGA;IACI;QACI,2BAA2B;IAC/B;AACJ;;AAEA;IACI;QACI,6BAA6B;IACjC;AACJ","sourcesContent":[".commonHeaderAdmin {\n\tposition: fixed !important;\n}\n\n.adminLayout {\n\tpadding-top: 64px !important;\n}\n\n.box h2 {\n\tfont-size: 21px;\n\tfont-weight: 600;\n}\n\n.exportLink {\n\tmargin-bottom: -29px;\n}\n\n.blockCenter {\n\tfloat: none !important;\n\tdisplay: block;\n\tmargin: 0 auto;\n\tmargin-top: 30px;\n}\n\n.panelHeader {\n\tpadding-bottom: 18px !important;\n\tpadding: 24px 15px;\n\tborder-radius: 6px !important;\n\tborder: 1px solid var(--primary-border)\n}\n\n.currencyselect {\n\twidth: 100%;\n\tmargin-right: 0px;\n}\n\n.panelHeader {\n\toverflow: hidden;\n\tposition: relative;\n}\n\n.mar0 {\n\tmargin-left: 0;\n\tmargin-right: 0;\n}\n\n@media screen and (max-width: 767px) {\n\t.blockCenter {\n\t\tpadding: 0px;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 24px 5px;\n\t}\n}","@import './newcommonstyle.css';\n\n/** Admin - Common - Start **/\n.sideAdminPageWrapper {\n\tmargin-left: var(--siteAdmin-sideBar-width);\n\tposition: relative;\n\tpadding: calc(var(--siteAdmin-header-height) + 28px) 25px 120px;\n}\n\n.panelHeader {\n\tborder-radius: 0;\n\twidth: 100%;\n\tdisplay: block;\n\tfont-size: 16px;\n\tpadding-bottom: 12px;\n\tborder-bottom: 1px solid var(--primary-border);\n\tbackground-color: var(--background-primary);\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.select {\n\tposition: relative;\n\tdisplay: inline-block;\n\tvertical-align: bottom;\n\tmargin-right: 5px;\n}\n\n.noMargin {\n\tmargin: 0px;\n}\n\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.labelTextNew {\n\tfont-size: 16px;\n\tline-height: 24px;\n\tfont-weight: 600;\n\tmargin: 0 0 6px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.displayInline {\n\tdisplay: inline-block;\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n.btnUPdate {\n\tdisplay: inline-block;\n}\n\n.btnModalDelete {\n\tdisplay: inline-block;\n\tmargin-left: 15px;\n}\n\n.radioBtn {\n\tposition: relative;\n\ttop: 1px;\n\tvertical-align: middle;\n}\n\n.backgroundImg {\n\tpadding-top: 80%;\n\tbackground-position: top center;\n\tbackground-size: cover;\n}\n\n@media screen and (max-width: 767px) {\n\t.btnUPdate {\n\t\tdisplay: block;\n\t\tmargin-bottom: 12px;\n\t}\n\n\t.btnModalDelete {\n\t\tdisplay: block;\n\t\tmargin-left: 0px;\n\t}\n\n\t.btnWidth {\n\t\twidth: 100%;\n\t}\n}\n\n/******************* Admin Modal ListSetting Start *******************/\n\n/******************* Admin Banner Image Section Start ****************/\n\n.bannerImageBg {\n\tpadding-top: 60%;\n\tbackground-repeat: no-repeat;\n\tbackground-size: contain;\n\tborder-radius: 4px;\n\tbackground-position: center;\n\tbackground-color: var(--secondary-gray-bg);\n\tborder: 1px dashed var(--primary-border);\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: -12px;\n\tright: 4px;\n}\n\n/*******************Admin Modal Start **********************/\n\n.modalRoot {\n\tpadding: 32px;\n}\n\n.modalBorderBottom {\n\tborder-bottom: 5px solid var(--primary-bg);\n\tborder-bottom-left-radius: 14px;\n\tborder-bottom-right-radius: 14px;\n}\n\n.logInModalBody {\n\tpadding: 0px;\n}\n\n/*************** Admin TableNew Design Start**************************/\n\n.exportSection {\n\tbackground: #f5f5f5;\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder-top-left-radius: 6px;\n\tborder-top-right-radius: 6px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--primary-foreground) !important;\n\ttext-decoration: none !important;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 12px;\n}\n\n.exportLinkImg {\n\tbackground: var(--common-white-primary-bg);\n\tpadding: 10px;\n\tborder-radius: 4px;\n\tdisplay: inline-block;\n}\n\n.vtrMiddle {\n\tvertical-align: middle;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 6px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-bottom: 1px solid var(--primary-border);\n}\n\n.profileImageSection {\n\twidth: 100%;\n\theight: 100px;\n\tmax-width: 100px;\n\tmax-height: 100px;\n\tborder-radius: 50%;\n}\n\n.lastviewInner {\n\tpadding: 10px;\n}\n\n.whyHostHoriLine {\n\tmargin: 30px 0;\n}\n\n.tableGrid {\n\tdisplay: grid;\n\tgrid-template-columns: 50% 50%;\n\tcolumn-gap: 10px;\n\tword-wrap: break-word;\n}\n\n.headingContent {\n\tfont-size: 18px;\n\tfont-weight: 500;\n}\n\n.refundTextColor {\n\tcolor: var(--alert-color);\n\tfont-size: 18px;\n\ttext-decoration: line-through;\n\ttext-decoration-thickness: 2px;\n\ttext-decoration-color: var(--black-color);\n}\n\n.dividerLine {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin: 30px 0;\n}\n\n.smallContent {\n\tfont-size: 14px;\n\tmargin-top: 6px;\n\tcolor: var(--secondary-foreground);\n}\n\n@media (max-width: 1200px) and (min-width: 1024px) {\n\t.sideAdminPageWrapper {\n\t\theight: 100%;\n\t\toverflow: auto;\n\t}\n}\n\n@media (max-width:1199px) {\n\t.sideAdminPageWrapper {\n\t\tmargin-left: 0;\n\t}\n}\n\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n\n}\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n}\n\n/*************** Admin TableNew Design End**************************/\n\n.ChangeToUpperCase {\n\ttext-transform: uppercase\n}\n\n.noBorder {\n\tborder: 0px !important;\n}\n\n/** Admin - Common - End **/\n\n/* site Admin utility Start */\n.siteAdminHeading {\n\tfont-size: 24px;\n\tline-height: 32px;\n\tfont-weight: 700;\n\tmargin: 0 0 24px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.siteAdminSubHeading {\n\tfont-size: 18px;\n\tline-height: 26px;\n\tfont-weight: 600;\n\tmargin: 0 0 12px;\n\ttext-align: start;\n\tcolor: var(--primary-foreground);\n}\n\n.adminFormDivider {\n\tborder-top: 1px solid var(--primary-border);\n\tmargin-bottom: 24px;\n}",".errorMessage {\n  margin: 5px 0px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n}","@import '../utils.css';\n\n.panelHeader {\n  border-radius: 0;\n  width: 100%;\n  display: block;\n  font-size: 16px;\n  padding-bottom: 12px;\n  border-bottom: 1px solid var(--primary-border);\n}\n\n.formGroup {\n  margin-bottom: 6px;\n}\n\n.select {\n  position: relative;\n  display: inline-block;\n  vertical-align: bottom;\n  margin-right: 5px;\n}\n\n.labelText {\n  font-size: 14px;\n  color: var(--secondary-foreground);\n  margin: 6px 0px;\n  line-height: 1.43;\n  font-weight: normal;\n  vertical-align: middle;\n}",".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n.spaceBottom20 {\n\tmargin-bottom: 20px;\n}\n\n.spaceBottom10 {\n\tmargin-bottom: 10px;\n}\n\n.marginNone {\n\tmargin: 0;\n}\n\n.spaceBottom15 {\n\tmargin-bottom: 15px;\n}\n\n.marginTopNone {\n\tmargin-top: 0;\n}\n\n.spaceTop11 {\n\tmargin-top: 11px;\n}\n\n.spaceTop21 {\n\tmargin-top: 21px;\n}\n\n.spaceTop20 {\n\tmargin-top: 20px;\n}\n\n.spaceTop10 {\n\tmargin-top: 10px;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}","@import '../../admin-common.css';\n@import '../../admin-form.css';\n@import '../../../helpers.css';\n\n.faqImage {\n    width: 100%;\n    max-width: 20px;\n    margin-left: 3px;\n    margin-bottom: 3px;\n}\n\n.labelAddon {\n    display: inline;\n}\n\n.labelAddonSec {\n    margin: 6px 0;\n}\n\n.addonStyle {\n    border: 1px solid var(--primary-border) !important;\n}\n\n.displayGrid {\n    display: grid;\n    grid-template-columns: 49% 49%;\n    grid-column-gap: 20px;\n}\n\n\n@media screen and (max-width: 1199px) {\n    .displayGrid {\n        grid-template-columns: 100%;\n    }\n}\n\n@media screen and (max-width:767px) {\n    .panelHeader {\n        padding: 24px 15px !important;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"commonHeaderAdmin": `EditCancellation-commonHeaderAdmin-IaSGv`,
	"adminLayout": `EditCancellation-adminLayout-faCeg`,
	"box": `EditCancellation-box-j5FUG`,
	"exportLink": `EditCancellation-exportLink-hf2go`,
	"blockCenter": `EditCancellation-blockCenter-ePAX5`,
	"panelHeader": `EditCancellation-panelHeader-U0gM3`,
	"currencyselect": `EditCancellation-currencyselect-_1pfD`,
	"mar0": `EditCancellation-mar0-_6onr`,
	"sideAdminPageWrapper": `EditCancellation-sideAdminPageWrapper-PcDxi`,
	"table": `EditCancellation-table-gQEZE`,
	"tableRow": `EditCancellation-tableRow-EwGn1`,
	"tableCell": `EditCancellation-tableCell-XaN4U`,
	"formGroup": `EditCancellation-formGroup-aPIAD`,
	"select": `EditCancellation-select-rvuZv`,
	"noMargin": `EditCancellation-noMargin-wcGJx`,
	"labelTextNew": `EditCancellation-labelTextNew-YNZZJ`,
	"displayInline": `EditCancellation-displayInline-LxLyr`,
	"btnUPdate": `EditCancellation-btnUPdate-Q6BHw`,
	"btnModalDelete": `EditCancellation-btnModalDelete-iP62s`,
	"radioBtn": `EditCancellation-radioBtn-jFqsK`,
	"backgroundImg": `EditCancellation-backgroundImg-eeYOe`,
	"btnWidth": `EditCancellation-btnWidth-KNWJH`,
	"bannerImageBg": `EditCancellation-bannerImageBg-dNUdY`,
	"bannerDelete": `EditCancellation-bannerDelete-EYcLJ`,
	"modalRoot": `EditCancellation-modalRoot-hYAgu`,
	"modalBorderBottom": `EditCancellation-modalBorderBottom-ZK1lP`,
	"logInModalBody": `EditCancellation-logInModalBody-jRcrQ`,
	"exportSection": `EditCancellation-exportSection-V4ElJ`,
	"exportSectionGridSub": `EditCancellation-exportSectionGridSub-Fcrwx`,
	"exportText": `EditCancellation-exportText-vKAKo`,
	"exportLinkImg": `EditCancellation-exportLinkImg-mogP7`,
	"vtrMiddle": `EditCancellation-vtrMiddle-OQ5wd`,
	"exportImg": `EditCancellation-exportImg-E0jJM`,
	"profileViewlabel": `EditCancellation-profileViewlabel-TSCp8`,
	"profileViewMainContent": `EditCancellation-profileViewMainContent-IUw1n`,
	"profileViewMain": `EditCancellation-profileViewMain-BieaE`,
	"profileViewInner": `EditCancellation-profileViewInner-pF6Ti`,
	"profileImageSection": `EditCancellation-profileImageSection-F7u3J`,
	"lastviewInner": `EditCancellation-lastviewInner-RWSN_`,
	"whyHostHoriLine": `EditCancellation-whyHostHoriLine-hU3Ib`,
	"tableGrid": `EditCancellation-tableGrid-k3Jzc`,
	"headingContent": `EditCancellation-headingContent-yf8H5`,
	"refundTextColor": `EditCancellation-refundTextColor-YfkBm`,
	"dividerLine": `EditCancellation-dividerLine-JMcBi`,
	"smallContent": `EditCancellation-smallContent-bHZ0s`,
	"ChangeToUpperCase": `EditCancellation-ChangeToUpperCase-EABJP`,
	"noBorder": `EditCancellation-noBorder-zwtWw`,
	"siteAdminHeading": `EditCancellation-siteAdminHeading-UYbNw`,
	"siteAdminSubHeading": `EditCancellation-siteAdminSubHeading-bgNJ3`,
	"adminFormDivider": `EditCancellation-adminFormDivider-tw0cO`,
	"errorMessage": `EditCancellation-errorMessage-AP3o4`,
	"labelText": `EditCancellation-labelText-bzbdt`,
	"space1": `EditCancellation-space1-zVLKW`,
	"space2": `EditCancellation-space2-TWNc6`,
	"space3": `EditCancellation-space3-phJpk`,
	"space4": `EditCancellation-space4-qNdxE`,
	"space5": `EditCancellation-space5-guK3I`,
	"space6": `EditCancellation-space6-SPbrA`,
	"space7": `EditCancellation-space7-eo6De`,
	"spaceTop8": `EditCancellation-spaceTop8-L7NZj`,
	"spaceTop1": `EditCancellation-spaceTop1-s5INw`,
	"spaceTop2": `EditCancellation-spaceTop2-qQy4q`,
	"spaceTop3": `EditCancellation-spaceTop3-Y3UGh`,
	"spaceTop4": `EditCancellation-spaceTop4-w1Zb4`,
	"spaceTop5": `EditCancellation-spaceTop5-AueTe`,
	"spaceTop6": `EditCancellation-spaceTop6-xFy98`,
	"spaceTop7": `EditCancellation-spaceTop7-R4kGQ`,
	"padding1": `EditCancellation-padding1-DWAqD`,
	"padding2": `EditCancellation-padding2-N7Pvg`,
	"padding3": `EditCancellation-padding3-pEWfl`,
	"padding4": `EditCancellation-padding4-w446A`,
	"padding5": `EditCancellation-padding5-_OWJ6`,
	"padding6": `EditCancellation-padding6-IMqgb`,
	"padding7": `EditCancellation-padding7-zMUo6`,
	"paddingTop1": `EditCancellation-paddingTop1-OHjtp`,
	"paddingTop2": `EditCancellation-paddingTop2-PBVtl`,
	"paddingTop3": `EditCancellation-paddingTop3-C8yX5`,
	"paddingTop4": `EditCancellation-paddingTop4-Fiw0E`,
	"paddingTop5": `EditCancellation-paddingTop5-M7RYc`,
	"paddingTop6": `EditCancellation-paddingTop6-FUYuR`,
	"paddingTop7": `EditCancellation-paddingTop7-Le7Jr`,
	"noPadding": `EditCancellation-noPadding-pGDtO`,
	"textBold": `EditCancellation-textBold-Dlivv`,
	"textBolder": `EditCancellation-textBolder-PAWPl`,
	"textNormal": `EditCancellation-textNormal-KkeeM`,
	"spaceBottom20": `EditCancellation-spaceBottom20-DU23c`,
	"spaceBottom10": `EditCancellation-spaceBottom10-GhnG1`,
	"marginNone": `EditCancellation-marginNone-oa5ss`,
	"spaceBottom15": `EditCancellation-spaceBottom15-k9MGe`,
	"marginTopNone": `EditCancellation-marginTopNone-YUJ7j`,
	"spaceTop11": `EditCancellation-spaceTop11-r2IsV`,
	"spaceTop21": `EditCancellation-spaceTop21-lXZbo`,
	"spaceTop20": `EditCancellation-spaceTop20-L5Zf1`,
	"spaceTop10": `EditCancellation-spaceTop10-hekGy`,
	"textDarkBlue": `EditCancellation-textDarkBlue-fqmOY`,
	"textLightBlue": `EditCancellation-textLightBlue-FgwjR`,
	"textLightSandleGreen": `EditCancellation-textLightSandleGreen-gvUpo`,
	"textLightBrown": `EditCancellation-textLightBrown-DprQR`,
	"textMediumMaroon": `EditCancellation-textMediumMaroon-vDgeM`,
	"textBrown": `EditCancellation-textBrown-mDudH`,
	"textMaroon": `EditCancellation-textMaroon-KcGQ5`,
	"textDarkBrown": `EditCancellation-textDarkBrown-g6riu`,
	"textMediumBrown": `EditCancellation-textMediumBrown-jbNWf`,
	"textSkyBlue": `EditCancellation-textSkyBlue-rPc_D`,
	"textGray": `EditCancellation-textGray-Fx_Kq`,
	"faqImage": `EditCancellation-faqImage-astH5`,
	"labelAddon": `EditCancellation-labelAddon-eWOUb`,
	"labelAddonSec": `EditCancellation-labelAddonSec-G80T9`,
	"addonStyle": `EditCancellation-addonStyle-TB1eC`,
	"displayGrid": `EditCancellation-displayGrid-cD8Ca`
};
module.exports = ___CSS_LOADER_EXPORT___;
